module.exports = __webpack_public_path__ + "static/img/logo_blue.433f1df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo_blue.png
// module id = izAT
// module chunks = 1